<script lang="ts">
    import type {LayoutData} from './$types';
    import Footer from './Footer.svelte';
    import Header from './Header.svelte';

    export let data: LayoutData;
</script>

<Header authorized={data.authorized} />

<main class="bg-white">
    <slot />
</main>

<Footer />
